import React from "react";

const Summary = () => <div className="row">
<div className="col-xl-4 col-md-6 mb-4">
  <div className="card border-left-primary shadow h-100 py-2">
    <div className="card-body">
      <div className="row no-gutters align-items-center">
        <div className="col mr-2">
          <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Web Applications</div>
          <div className="h5 mb-0 font-weight-bold text-gray-800">20+</div>
        </div>
        <div className="col-auto">
          <i className="fas fa-puzzle-piece fa-2x text-gray-300"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="col-xl-4 col-md-6 mb-4">
  <div className="card border-left-warning shadow h-100 py-2">
    <div className="card-body">
      <div className="row no-gutters align-items-center">
        <div className="col mr-2">
          <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Mobile Applications</div>
          <div className="h5 mb-0 font-weight-bold text-gray-800">7+</div>
        </div>
        <div className="col-auto">
          <i className="fas fa-mobile fa-2x text-gray-300"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="col-xl-4 col-md-6 mb-4">
  <div className="card border-left-danger shadow h-100 py-2">
    <div className="card-body">
      <div className="row no-gutters align-items-center">
        <div className="col mr-2">
          <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Awards</div>
          <div className="h5 mb-0 font-weight-bold text-gray-800">7+</div>
        </div>
        <div className="col-auto">
          <i className="fas fa-trophy fa-2x text-gray-300"></i>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

export default Summary;